import React from "react";
import styles from "./Static.module.scss";

const DataDeletion = () => {
	return (
		<div className="App">
			<div className={`MainContainer ${styles.Main}`}>
				<div className={styles.Wrapper}>
					<h2>Data Deletion Instructions</h2>
					<article>
						<p>
							At Fameo, we value your privacy and provide you with full control over your data. If you wish to delete your account or any personal information associated with your Fameo account, please follow the instructions below.
						</p>

						<ul>
							<li className={styles.li}>Option 1: Delete via the App Settings (Recommended)</li>
							<>
								<p>
									The fastest way to delete your data is directly through the Fameo application:
								</p>
								<ol>
									<li>Log in to your Fameo account on your mobile device or web browser.</li>
									<li>Navigate to the <b>Settings</b> menu (accessible via your profile icon).</li>
									<li>Select <b>Security</b> or <b>Account Management</b>.</li>
									<li>Click on <b>Delete Account</b>.</li>
									<li>Confirm your request. Once confirmed, all your personal data (posts, photos, profile information) will be permanently removed from our active servers.</li>
								</ol>
							</>

							<li className={styles.li}>Option 2: Manual Data Deletion Request</li>
							<>
								<p>
									If you are unable to access your account or prefer to request deletion via email, you can contact our data privacy team:
								</p>
								<p>
									Send an email to <b>support@fameo.com</b> with the subject line <b>"Data Deletion Request"</b>.
								</p>
								<p>
									In your email, please provide:
								</p>
								<ul>
									<li>Your full name</li>
									<li>Your registered email address or username</li>
									<li>A brief statement confirming that you wish to have your data deleted.</li>
								</ul>
								<p>
									Our team will process your request within 30 days and send you a confirmation once your data has been purged from our systems.
								</p>
							</>

							<li className={styles.li}>What data will be deleted?</li>
							<>
								<p>
									Upon processing a deletion request, the following information will be permanently removed:
								</p>
								<ul>
									<li>Your profile information (name, bio, profile picture).</li>
									<li>All posts, including photos and videos.</li>
									<li>Your list of followers and people you follow.</li>
									<li>Direct messages (except where required to be retained by law).</li>
								</ul>
								<p>
									<i>Note: Some data may be retained for a limited period in our backup systems for disaster recovery purposes or as required by legal obligations.</i>
								</p>
							</>
						</ul>
					</article>
				</div>
			</div>
		</div>
	);
};

export default DataDeletion;


